import { get } from 'lodash-es'

import { InPersonLocation } from '../../models/calendar/CalendarV2'
import { Address } from '../../models/providers/Providers'

export const formatAddressForSubmission = (address: Address | InPersonLocation) => {
  return [
    address.street1 || get(address, 'address1', ''),
    address.street2 ? address.street2 : '',
    address.city ?? '',
    address.state ?? '',
    address.zipcode ?? address.zip ?? '',
  ]
    .filter((address) => address !== '')
    .join(', ')
}
